import { LanguageModelRequest } from '#types/System.Agents.types';
import type { ResponseHandler } from '../types';
import { readSSEStream } from '../streamParsers';

type AgenticRequest = LanguageModelRequest & {
    agenticMode: NonNullable<LanguageModelRequest['agenticMode']>;
};

/** Idle watchdog window covering 3 missed 20s server heartbeats. */
const STREAM_IDLE_TIMEOUT_MS = 75_000;

export const agenticHandler: ResponseHandler<AgenticRequest> = {
    isApplicable: (r): r is AgenticRequest => 'agenticMode' in r && !!r.agenticMode,
    handle: async (response, _request, { onEvent, onComplete, abort }) => {
        if (!response.body) throw new Error('Failed to get readable stream');
        if (!onEvent) throw new Error('onEvent required for agentic mode');
        await readSSEStream(response.body.getReader(), onEvent, () => onComplete?.(), {
            idleTimeoutMs: STREAM_IDLE_TIMEOUT_MS,
            onIdleTimeout: abort,
        });
    },
};
